import { render, staticRenderFns } from "./AssignPersonInChargeDialog.vue?vue&type=template&id=33ab8716&scoped=true"
import script from "./AssignPersonInChargeDialog.vue?vue&type=script&lang=js"
export * from "./AssignPersonInChargeDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignPersonInChargeDialog.vue?vue&type=style&index=0&id=33ab8716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ab8716",
  null
  
)

export default component.exports